import React from 'react';
import {useIntl} from 'react-intl';
import Styled from 'styled-components';
import {FlexColumn, Text, tokensForThemeProvider} from '@forecast-it/design-system';

const Content = Styled(FlexColumn)`
	padding: 64px 0px;
	border: 1px solid ${tokensForThemeProvider.sky.sys.color.border.decorative};
	border-radius: 8px;
`;

type Props = {hasTemplates: boolean; query: string};

/**
 * Says why the list is empty: the company has no templates yet, the search matched nothing, or, with
 * no search, the inactive filter hides them all. Creating one is always the list header's button.
 */
export const BaselineTemplatesEmptyState = ({hasTemplates, query}: Props): JSX.Element => {
	const {formatMessage} = useIntl();
	if (hasTemplates && !query) {
		return (
			<div data-cy="baseline-templates-no-active">
				<Content gap="xl" alignItems="center" justifyContent="center">
					<Text>{formatMessage({id: 'baseline_templates.list.no_active'})}</Text>
				</Content>
			</div>
		);
	}
	if (hasTemplates) {
		return (
			<div data-cy="baseline-templates-no-match">
				<Content gap="xl" alignItems="center" justifyContent="center">
					<Text>{formatMessage({id: 'baseline_templates.list.no_match'}, {query})}</Text>
				</Content>
			</div>
		);
	}
	return (
		<div data-cy="baseline-templates-empty">
			<Content gap="xl" alignItems="center" justifyContent="center">
				<Text>{formatMessage({id: 'baseline_templates.list.empty_title'})}</Text>
			</Content>
		</div>
	);
};
